if (!customElements.get('card-images-alternate')) {
  class CardImagesAlternate extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;

      // Support Shopify theme editor: highlight active block
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId !== this.sectionId) return;
          const target = e.target;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }
  }

  customElements.define('card-images-alternate', CardImagesAlternate);
}
